import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "EmployeePointRecord" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import localCache from "@/utils/cache";
import {useStore} from "@/store";



export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeePointRecord',
  setup(__props) {

const store = useStore()

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.id};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'empId')
  userItem!.options = userOptions;
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return {title: item.name, value: item.id}
  })
}
getDept()

const handleSortChange = (value: any) => {
  let orderBy = value.prop;
  if (orderBy) {
    orderBy = orderBy.replace('Desc', '')
  }
  store.commit('system/changeOrderInfo', {
    orderBy: orderBy,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "employeePointRecord",
      onSortChange: handleSortChange
    }, {
      useStatus: _withCtx((scope) => [
        (scope.row.useStatus === '0')
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              size: "mini",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("未使用")
              ]),
              _: 1
            }))
          : (scope.row.useStatus === '1')
            ? (_openBlock(), _createBlock(_component_el_tag, {
                key: 1,
                size: "mini",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("已使用")
                ]),
                _: 1
              }))
            : (scope.row.useStatus === '2')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 2,
                  size: "mini",
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("已失效")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})